import * as XLSX from 'xlsx';

const normalizeName = (name) => {
  return String(name || '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
};

export async function parseTwoColumnExcel(file) {
  if (!file) throw new Error('Файл не выбран');
  const buffer = await file.arrayBuffer();
  let workbook;
  try {
    workbook = XLSX.read(buffer, { type: 'array' });
  } catch (err) {
    throw new Error('Не удалось прочитать Excel-файл');
  }
  const sheetName = workbook.SheetNames[0];
  if (!sheetName) throw new Error('Лист Excel не найден');
  const worksheet = workbook.Sheets[sheetName];
  const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
  const items = [];
  for (const row of rows) {
    if (!Array.isArray(row)) continue;
    const rawName = row[0];
    const rawQty = row[1];
    if (rawName == null || rawName === '') continue;
    const normalized = normalizeName(rawName);
    if (!normalized || normalized === 'наименование') continue;
    const qty = Number(String(rawQty ?? '').replace(/,/, '.').replace(/\s/g, ''));
    if (!Number.isFinite(qty) || qty <= 0) continue;
    items.push({
      originalName: String(rawName).trim(),
      normalizedName: normalized,
      quantity: qty,
    });
  }
  if (!items.length) throw new Error('В файле не найдено строк для импорта');
  return items;
}

export function matchExcelItems(excelItems, dictItems) {
  const dictByName = new Map();
  for (const item of dictItems || []) {
    const key = normalizeName(item?.name);
    if (!key || dictByName.has(key)) continue;
    dictByName.set(key, item);
  }
  const matched = [];
  const missing = [];
  for (const excelItem of excelItems) {
    const dict = dictByName.get(excelItem.normalizedName);
    if (dict) matched.push({ excel: excelItem, dict });
    else missing.push(excelItem.originalName);
  }
  return { matched, missing };
}
